import React from "react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { Pagination } from "components";
import BranchRequestStatus from "./BranchRequestStatus";

const BranchRequestListTable = ({
  isLoading,
  branchRequestList,
  pagination,
  checkedUsers,
  onCheckBoxChange,
  refetch,
  onChangePage,
}) => {
  const { t: getLabel } = useTranslation();

  const handleCheckboxChange = (isCheckAll, isChecked, id) => {
    onCheckBoxChange(isCheckAll, isChecked, id);
  };

  const currentPage = pagination.offset / pagination.limit + 1;
  const totalPages = pagination.total_pages;

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <table className="table table-vcenter">
          <thead>
            <tr>
              <th style={{ width: "5%" }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  onChange={e => handleCheckboxChange(true, e.target.checked, null)}
                  checked={
                    checkedUsers.length > 0 &&
                    checkedUsers.length ===
                      branchRequestList.filter(
                        data => data.status === SystemConstant.BRANCH_REQUEST_STATUS.REJECTED.status,
                      ).length
                  }
                />
              </th>
              <th style={{ width: "10%" }}>
                <strong>Họ và tên</strong>
              </th>
              <th style={{ width: "13%" }}>
                <strong>Số điện thoại</strong>
              </th>
              <th style={{ width: "13%" }}>
                <strong>Email</strong>
              </th>
              <th style={{ width: "28%" }}>
                <strong>Ghi chú từ người yêu cầu</strong>
              </th>
              <th style={{ width: "13%", textAlign: "center" }}>
                <strong>Trạng thái</strong>
              </th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan={7} className="text-center">
                  <small>{getLabel(LangConstant.TXT_LOADING)}</small>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {branchRequestList.length > 0 ? (
                branchRequestList.map((user, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        onChange={e => handleCheckboxChange(false, e.target.checked, user.id)}
                        checked={checkedUsers.includes(user.id)}
                        disabled={user.status !== SystemConstant.BRANCH_REQUEST_STATUS.REJECTED.status}
                      />
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-3">
                        <span style={{ fontSize: "14px" }}>{user.name}</span>
                      </div>
                    </td>
                    <td>{user.phone || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                    <td>{user.email || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                    <td>{user.note || getLabel(LangConstant.TXT_NOT_FOUND)}</td>
                    <td className="text-center">
                      <BranchRequestStatus user={user} refetch={refetch} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center">
                    <small>{getLabel(LangConstant.TXT_NOT_FOUND)}</small>
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {totalPages > 0 && (
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onChangePage} />
      )}
    </div>
  );
};

export default BranchRequestListTable;
